import(/* webpackMode: "eager" */ "/vercel/path0/rosetai/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/rosetai/components/I18nProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/rosetai/context/AuthContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/rosetai/context/LanguageContext.js");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/vercel/path0/rosetai/context/ThemeContext.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/rosetai/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/rosetai/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/rosetai/node_modules/next/font/google/target.css?{\"path\":\"app/layout.js\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
